[<template>
  <div>
    <el-table :data="artists.data" class="w100" stripe>
      <el-table-column label="Name" prop="name"></el-table-column>
      <el-table-column label="Actions" align="right" width="200%">
        <template slot-scope="props">
          <el-tooltip content="Delete" placement="top">
            <el-button
              type="danger"
              circle
              size="small"
              icon="el-icon-close"
              @click="deleteA(props.row.id)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState('newReleasesCarousel', ['artists'])
  },

  methods: {
    ...mapActions('newReleasesCarousel', [
      'read',
      'delete'
    ]),
    ...mapMutations('newReleasesCarousel', ['setDialog']),
    deleteA(id) {
      this.$confirm('You will permanently delete artist from carousel. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
        .then(() => {
          this.delete(id)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete cancelled'
          })
        })
    }
  },

  created() {
    this.read()
  }
}
</script>
]
